import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9490cb2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 1,
  class: "news-post-image-container"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "news-post-tags" }
const _hoisted_5 = { class: "news-post-content" }
const _hoisted_6 = {
  key: 0,
  class: "news-post-tags"
}
const _hoisted_7 = { class: "news-post-title" }
const _hoisted_8 = { class: "news-post-date" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic xs ic-calendar" }, null, -1))
const _hoisted_10 = { class: "news-post-excerpt" }


import { format } from 'date-fns';
import { BlogPost } from '../types/BlogPost';

interface Props {
  post: BlogPost;
  layout?: 'default' | 'main';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPost',
  props: {
    post: {},
    layout: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout === 'main' ? 'div' : 'a'), {
    class: "news-post",
    layout: _ctx.layout,
    href: _ctx.layout === 'main' ? null : `/news/${_ctx.post.slug}`,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.layout !== 'main' && _ctx.$router.push(`/news/${_ctx.post.slug}`)), ["prevent"]))
  }, {
    default: _withCtx(() => [
      (_ctx.layout === 'main')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/news/${_ctx.post.slug}`,
            class: "news-post-image-container"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "news-post-image",
                src: _ctx.post.picture?.url,
                alt: _ctx.post.title
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "news-post-image",
              src: _ctx.post.picture?.url,
              alt: _ctx.post.title
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.categories, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "news-post-tag",
                  key: category
                }, _toDisplayString(category), 1))
              }), 128))
            ])
          ])),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.layout === 'main')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.categories, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "news-post-tag",
                  key: category
                }, _toDisplayString(category), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.post.title), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_unref(format)(_ctx.post.published_at || _ctx.post.created_at, 'ccc d LLLL, yyyy')), 1)
          ]),
          _createElementVNode("span", null, _toDisplayString(_unref(format)(_ctx.post.published_at || _ctx.post.created_at, 'HH:mm')) + " GMT", 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(_ctx.post.excerpt), 1)
        ]),
        (_ctx.layout === 'main')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "btn outlined blue",
              to: `/news/${_ctx.post.slug}`
            }, {
              default: _withCtx(() => [
                _createTextVNode("read more")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["layout", "href"]))
}
}

})